import { render, staticRenderFns } from "./NewTransferImprovementsModalSection.vue?vue&type=template&id=ab502d3a&scoped=true"
import script from "./NewTransferImprovementsModalSection.vue?vue&type=script&lang=js"
export * from "./NewTransferImprovementsModalSection.vue?vue&type=script&lang=js"
import style0 from "./NewTransferImprovementsModalSection.vue?vue&type=style&index=0&id=ab502d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab502d3a",
  null
  
)

export default component.exports